import { useEffect, useState } from 'react'

import InfluencerDetails from '@src/quince-site-common/src/domains/InfluencerDetails'
import Product from '@src/quince-site-common/src/domains/Product'
import productService from '@src/quince-site-common/src/services/productService'
import { captureFatalException } from '@src/quince-site-common/src/utils/sentryUtil'

import { InfluencerCardProductDetails } from '../atoms/influencerCard/InfluencerCard'
import { getInitialSelectedOptions, isNestedProduct } from '../molecules/productCard/productCard.helpers'

function useInfluencerCardProducts(influencerDetailList: InfluencerDetails[]) {
  const [isLoadingProducts, setIsLoadingProducts] = useState<boolean>(true)
  const [products, setProducts] = useState<Product[]>()
  const [shopifyProductIdToProductMap, setShopifyProductIdToProductMap] = useState<
    Record<number, InfluencerCardProductDetails>
  >({})

  useEffect(() => {
    void (async () => {
      const shopifyProductIds = influencerDetailList
        .map(influencerDetail => influencerDetail.shopifyProductId)
        .filter(id => id != null)

      try {
        setIsLoadingProducts(true)
        const products = await productService.getProducts({
          shopifyProductIds,
          useLite: true,
        })
        const shopifyProductIdToProductMap: Record<number, InfluencerCardProductDetails> = {}
        products.forEach(product => {
          const selectedOptions = getInitialSelectedOptions(product, [], true, false, isNestedProduct(product) ? 2 : 1)
          shopifyProductIdToProductMap[product.shopifyProductId] = {
            product,
            selectedOptions,
            productTags: product.tags,
          }
        })

        setShopifyProductIdToProductMap(shopifyProductIdToProductMap)
        setProducts(products)
      } catch (error) {
        captureFatalException('Failed to fetch products in InfluencerSection section', {
          error: JSON.stringify(error),
        })
      } finally {
        setIsLoadingProducts(false)
      }
    })()
  }, [influencerDetailList])

  return {
    isLoadingProducts,
    products,
    shopifyProductIdToProductMap,
  }
}

export { useInfluencerCardProducts }
